export const getImpersonateCookie = () =>
  document.cookie
    .split("; ")
    .filter((row) => row.startsWith("trmgmt.impersonate="))
    .map((c) => c.split("=")[1])[0];
